// extracted by mini-css-extract-plugin
module.exports = {"LogoDiv":"Logo_LogoDiv__1i7uR","Logo":"Logo_Logo__1N0xH","glitch1":"Logo_glitch1__3ZpXp"};